import { Skeleton } from '@chakra-ui/react'
import React, { useContext } from 'react'
import {Link} from 'react-router-dom'
import './categories.css'
import { Context } from './context/Context'

function Categories() {

    const {isCategoriesLoading, categories} = useContext(Context)

  return (
    <Skeleton isLoaded={isCategoriesLoading}>
        <section id="categories" className='my-24'>
            <div className='flex flex-row justify-center items-center'>
                <span className=' font-nunito text-rosemadder text-6xl font-bold mb-8'>Categories</span>
            </div>
            <div className='tilesContainer'>
                {categories.map((item) => {
                    const {id, categoryTitle, categoryImage} = item

                return (
                        <Link to={`category/${categoryTitle}`}>
                            <div key={id} className="categoryTiles" style={{background:`url(${categoryImage})`, backgroundSize:'cover', width:'250px', height:'250px',backgroundPosition:'center'}}>
                                <div className=' bg-black/40 w-full h-full flex flex-col justify-center items-center'>
                                    <h2 className='font-bold font-nunito text-white text-2xl'>{categoryTitle}</h2>
                                </div>
                                
                            </div>
                        </Link>
                )
                })}
            </div>
        </section>
    </Skeleton>
  )
}

export default Categories